//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import {
  IGetLinkMetadataRequest,
  IGetLinkMetadataResponse,
  ILinkMetadataResponse,
} from '@apis/twitter-post-details/twitterPostDetailsApiModel';
import { serializedGatewayFetch } from '@utils/sessionFetch';

function postDetailsFetch(endpoint: string, init?: RequestInit) {
  return serializedGatewayFetch(
    'twitter_gateway',
    `/api/v1/twitter/${endpoint}`,
    init,
  );
}

/**
 * Get link metadata for provided URL
 *
 * POST /api/v1/twitter/link-metadata
 */
export async function getLinkMetadata(
  req: IGetLinkMetadataRequest,
): Promise<ILinkMetadataResponse | undefined> {
  const res = await postDetailsFetch('link-metadata', {
    method: 'POST',
    body: JSON.stringify(req),
  });
  const getLinkMetadataResponse = await res.json<IGetLinkMetadataResponse>();

  return getLinkMetadataResponse.data;
}
